module.exports = __webpack_public_path__ + "static/media/OpenSans-Bold.93fe8f34.woff2";